/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-19 10:31:23
 * @LastEditTime: 2021-05-14 11:18:18
 * @LastEditors: Please set LastEditors
 */
// import {api} from '../../utils/api'

export default {
  state: {
    uid: 0,
    userInfo: {},
    aesid: 0,
    session: '',
    guid: '',
    version: ''
  },
  getters: {
    uid: state => {
      return state.uid// 用户的encrypt
    },
    guid: state => {
      return state.guid
    },
    version: state => {
      return state.version
    },
    session: state => {
      return state.session
    },
    userInfo: state => {
      return state.userInfo
    }
  },
  mutations: {
    loginIn (state, uid) {
      state.uid = uid
    },
    setUserInfo (state, info, flg) {
      console.log('setUserInfo',info)
      state.userInfo = info
    },
    setUserVersion (state, version, flg) {
      state.version = version
    },
    setBaseInfo (state, info) {
      console.log('setBaseInfo',info)
      state.uid = info.uid
      state.version = info.version
      state.session = info.session
      state.guid = info.guid
      state.userInfo = info
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js